import { CustomPermission } from '../../../../../@types';
import { PartActionTypes } from '../../../../../@types/partAction.type';
import { NextServiceStatusesResponse, ServiceObject } from '../../../../../@types/service.type';

export interface FileUploadError {
  type: 'maxFiles' | 'fileSize' | 'totalSize';
  message: string;
}

export interface MobileActionBarProps {
  service: ServiceObject;
  nextStatuses: NextServiceStatusesResponse | undefined;
  partActionTypes: PartActionTypes[] | undefined;
  permissions: CustomPermission[] | undefined;
  onTakePhoto: (file: File) => void;
  onUploadFiles: (files: File[]) => void;
  onUploadError?: (error: FileUploadError) => void;
  onStatusChanged: () => void | Promise<void>;
  onNoteAdded: () => void | Promise<void>;
  onPartActionComplete: () => void | Promise<void>;
}

// File upload constraints
export const FILE_UPLOAD_LIMITS = {
  maxFiles: 6,
  maxFileSizeMB: 10,
  maxTotalSizeMB: 50,
} as const;
